import { render } from "./FilterTab.vue?vue&type=template&id=3bec0656&scoped=true"
import script from "./FilterTab.vue?vue&type=script&lang=js"
export * from "./FilterTab.vue?vue&type=script&lang=js"

import "./FilterTab.vue?vue&type=style&index=0&id=3bec0656&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bec0656"]])

export default __exports__